exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".account-app-popup .info-editor {\n  padding: 16px;\n  width: 90vw;\n  max-width: 700px;\n}\n.account-app-popup .info-editor > :not(:first-child) {\n  margin-top: 16px;\n}\n", ""]);
